// eslint-disable-next-line no-shadow
enum ZxyRegistrationStates {
    Enabled = 'enabled',
    Disabled = 'disabled',
    Deleted = 'deleted',
}

export { ZxyRegistrationStates };
